/* eslint-disable-next-line no-restricted-imports */
import type { Store, StoreSpecial } from '@jane/shared/models';
import type { Identification } from '@jane/shared/types';

import { isEligibleForGroup } from './qualifiedGroup';

export const isEligibleForGroupDiscount = ({
  document,
  special,
  store,
  timezone,
}: {
  document: Identification;
  special?: StoreSpecial;
  store: Store;
  timezone: string;
}): boolean => {
  const groupRules = special?.rules?.base;
  if (!(special && groupRules?.type)) return false;

  return isEligibleForGroup({
    document,
    timezone,
    groupType: groupRules.type,
    requiredAge: groupRules.required_age,
    store,
    verificationType: groupRules.verification_type,
  });
};
